module.exports = __webpack_public_path__ + "static/sypialnia-a869978e04395723cc3c10ed1505d65b.jpg";